import React, { useState, useEffect } from "react";
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Inputs from '../Common/Inputs';
import Output from '../Common/Output';
import RandomContent from '../Components/RandomContent';
import { formatHtml } from "../Conversion/HtmlFormat";

const HtmlFormatter = () => {
    const [inputData, setInputData] = useState('');
    const [outputData, setOutputData] = useState('');
    const [isError, setIsError] = useState(false);
    const [fontSize, setFontSize] = useState(14);
    const [inputLnCol, setInputLnCol] = useState({ line: 1, column: 1 });
    const [outputLnCol, setOutputLnCol] = useState({ line: 1, column: 1 });

    useEffect(() => {
        setInputData('');
        setOutputData('');
        setIsError(false);
    }, []);

    const handleFormat = () => {
        try {
            const formatted = formatHtml(inputData);
            setOutputData(formatted);
            setIsError(false);
        } catch (error) {
            setOutputData("Error formatting HTML");
            setIsError(true);
        }
    };

    return (
        <>
            <div>
                <Header />

                <RandomContent />

                {/* Intro Section */}
                <div className="blog-area pb-20">
                    <div className="container-block-fluid">
                        <div className="row justify-content-center">
                            <div className="full-col col-lg-12 col-md-12">
                                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                                    <div className="details">
                                        <h4><a href="#">Format HTML</a></h4>
                                        <p>
                                            Beautify your HTML code effortlessly with Data Beautifier's Free HTML Formatter Online Tool.
                                            Our Best HTML Formatter Online Tool enhances code readability by organizing and structuring your HTML files efficiently.
                                            Whether you're a seasoned developer or a beginner, our Simple HTML Formatter Tool is designed for ease of use,
                                            requiring no prior expertise. With the Easy HTML Formatter Tool, you can format messy HTML code in seconds,
                                            ensuring clean and professional results every time. Available 24/7 and free of charge,
                                            Data Beautifier is the ultimate solution for optimizing your HTML formatting needs.
                                            Try it today for hassle-free results!
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Input / Button / Output Section */}
                <div className="blog-area pb-20">
                    <div className="container-block-fluid">
                        <div className="row justify-content-center">

                            {/* Input Box */}
                            <div className="full-col col-lg-5 col-md-5">
                                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                                    <div className="thumb">
                                        <Inputs
                                            value={inputData}
                                            setValue={(val) => {
                                                setInputData(val);
                                                setIsError(false);
                                            }}
                                            fontSize={fontSize}
                                            setFontSize={setFontSize}
                                            isError={isError}
                                            lineCol={inputLnCol}
                                            setLineCol={setInputLnCol}
                                            readOnly={false}
                                            idPrefix="input"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Format Button */}
                            <div
                                className="w3-col m2"
                                style={{
                                    flex: 2,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <button
                                    className="default-btn icon four"
                                    onClick={handleFormat}
                                    disabled={!inputData.trim()}
                                >
                                    <i className="ri-braces-line"></i>
                                    Format HTML
                                </button>
                            </div>

                            {/* Output Box */}
                            <div className="full-col col-lg-5 col-md-5">
                                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="1200">
                                    <div className="thumb">
                                        <Output
                                            value={outputData}
                                            lineCol={outputLnCol}
                                            setLineCol={setOutputLnCol}
                                            fontSize={fontSize}
                                            setFontSize={setFontSize}
                                            isError={isError}
                                            readOnly={true}
                                            idPrefix="output"
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default HtmlFormatter;
